import { Breadcrumb, Typography, Button, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import lang from "src/lang";
import { useNavigate } from "react-router-dom";
import RoleTable from "./RoleTable";

const { Title } = Typography;

const Role: React.FC = () => {
  const navigate = useNavigate();
  const handleAddRoleClick = () => {
    navigate("/modules/setting/users/role/add");
  };

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("setting", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>
          {lang.get("setting", ["User Management"])}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{lang.get("setting", ["Roles"])}</Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("setting", ["User Roles"])}
      </Title>

      {/* Filter and Actions */}
      <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: "left" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddRoleClick}
          >
            {lang.get("setting", ["New Role"])}
          </Button>
        </Col>
      </Row>

      {/* Table */}
      <RoleTable />
    </div>
  );
};

export default Role;
